import { AsyncPipe } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FwDialogsModule, FwSnackbarContainerComponent } from '@flywheel-io/vision';
import { filter, map, of, startWith } from 'rxjs';

import { ConfigService } from '../../../config.service';
import { isSearchPath } from '../../../search/search.utils';
import { OperationFeedback } from '../../../xfer/components/operation-feedback/operation-feedback.component';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [SharedModule, FwDialogsModule, FwSnackbarContainerComponent, RouterModule, AsyncPipe, OperationFeedback],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutComponent implements OnInit {
  private router = inject(Router);
  protected configService = inject(ConfigService);

  route$ = of({
    isLogin: false,
    isSearch: false,
  });

  ngOnInit(): void {
    // NavigationEnd, not NavigationStart: the latter fires before the guards, so a navigation
    // cancelled by ChangeManagerGuard would swap the sidebar out on a page we never left.
    // The router commits the new url before activating this component, so router.url seeds the
    // navigation that created us - without it, a reload on /search renders the default sidebar.
    this.route$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this.router.url),
      map((url) => {
        return {
          isLogin: url === '/login',
          isSearch: isSearchPath(url),
        };
      }),
    );
  }
}
